module.exports = __webpack_public_path__ + "assets/f040ed1169d3fc0e8fdee304050e1c05.mp3";